<app-responsive-topbar></app-responsive-topbar>
<div class="bg-container centered" style="display: flex; justify-content: center;">
    <router-outlet></router-outlet>
</div>